export enum PostType {
  URL = 0,
  VIDEO = 1,
  AUDIO = 2,
  IMAGE = 3,
  TEXT = 4,
  DOCUMENT = 6,
  MEDIA = 7
}

export enum NewsPostType {
  URL = 0,
  VIDEO = 1,
  AUDIO = 2,
  IMAGE = 3,
  TEXT = 4,
  LIVE = 6
}

export enum PostStatus {
  ACTIVE = 'ACTIVE',
  PROCESSING = 'PROCESSING',
  SCHEDULED = 'SCHEDULED'
}
